export default "__VITE_ASSET__DGb3v4Cm__"